class FakePurchaseNotification extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.timeoutId = null;
    this.isVisible = false;
    this.init();
  }

  init() {
    // Load products from JSON
    const productsScript = document.querySelector('script[data-products-json]');
    if (productsScript) {
      try {
        this.products = JSON.parse(productsScript.textContent);
      } catch (e) {
        console.error('Failed to parse products JSON:', e);
        return;
      }
    }

    if (this.products.length === 0) {
      return;
    }

    // Get settings
    this.minInterval = parseInt(this.dataset.minInterval) || 10;
    this.maxInterval = parseInt(this.dataset.maxInterval) || 30;
    this.position = this.dataset.position || 'bottom-right';
    this.showClose = this.dataset.showClose === 'true';

    // Setup close button
    const closeBtn = this.querySelector('.m-fake-purchase-notification__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hide());
    }

    // Show first notification immediately after page load (delay 2-3 seconds for better UX)
    const initialDelay = Math.floor(Math.random() * 1000) + 2000; // 2-3 seconds
    setTimeout(() => {
      this.show();
    }, initialDelay);
  }

  getRandomProduct() {
    return this.products[Math.floor(Math.random() * this.products.length)];
  }

  getRandomName() {
    const firstNames = [
      'John', 'Sarah', 'Michael', 'Emily', 'David', 'Jessica', 'James', 'Ashley',
      'Robert', 'Amanda', 'William', 'Melissa', 'Richard', 'Deborah', 'Joseph', 'Stephanie',
      'Thomas', 'Rebecca', 'Christopher', 'Sharon', 'Daniel', 'Laura', 'Matthew', 'Michelle',
      'Anthony', 'Kimberly', 'Mark', 'Amy', 'Donald', 'Angela', 'Steven', 'Brenda',
      'Paul', 'Emma', 'Andrew', 'Olivia', 'Joshua', 'Cynthia', 'Kenneth', 'Marie',
      'Kevin', 'Janet', 'Brian', 'Catherine', 'George', 'Frances', 'Timothy', 'Christine',
      'Ronald', 'Samantha', 'Edward', 'Debra', 'Jason', 'Rachel', 'Jeffrey', 'Carolyn',
      'Ryan', 'Janet', 'Jacob', 'Virginia', 'Gary', 'Maria', 'Nicholas', 'Heather',
      'Eric', 'Diane', 'Jonathan', 'Julie', 'Stephen', 'Joyce', 'Larry', 'Victoria',
      'Justin', 'Kelly', 'Scott', 'Christina', 'Brandon', 'Joan', 'Benjamin', 'Evelyn',
      'Samuel', 'Judith', 'Gregory', 'Megan', 'Alexander', 'Cheryl', 'Patrick', 'Andrea',
      'Frank', 'Hannah', 'Raymond', 'Jacqueline', 'Jack', 'Martha', 'Dennis', 'Gloria',
      'Jerry', 'Teresa', 'Tyler', 'Sara', 'Aaron', 'Janice', 'Jose', 'Marie',
      'Henry', 'Julia', 'Adam', 'Grace', 'Nathan', 'Judy', 'Zachary', 'Theresa',
      'Douglas', 'Madison', 'Kyle', 'Beverly', 'Noah', 'Denise', 'Ethan', 'Marilyn',
      'Jeremy', 'Amber', 'Walter', 'Danielle', 'Mason', 'Brittany', 'Christian', 'Diana',
      'Keith', 'Abigail', 'Roger', 'Jane', 'Gerald', 'Lori', 'Carl', 'Mason',
      'Harold', 'Olivia', 'Dylan', 'Grace', 'Ralph', 'Sophia', 'Roy', 'Isabella'
    ];

    const lastNames = [
      'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis',
      'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Wilson', 'Anderson', 'Thomas', 'Taylor',
      'Moore', 'Jackson', 'Martin', 'Lee', 'Thompson', 'White', 'Harris', 'Sanchez',
      'Clark', 'Ramirez', 'Lewis', 'Robinson', 'Walker', 'Young', 'Allen', 'King',
      'Wright', 'Scott', 'Torres', 'Nguyen', 'Hill', 'Flores', 'Green', 'Adams',
      'Nelson', 'Baker', 'Hall', 'Rivera', 'Campbell', 'Mitchell', 'Carter', 'Roberts',
      'Gomez', 'Phillips', 'Evans', 'Turner', 'Diaz', 'Parker', 'Cruz', 'Edwards',
      'Collins', 'Reyes', 'Stewart', 'Morris', 'Morales', 'Murphy', 'Cook', 'Rogers',
      'Gutierrez', 'Ortiz', 'Morgan', 'Cooper', 'Peterson', 'Bailey', 'Reed', 'Kelly',
      'Howard', 'Ramos', 'Kim', 'Cox', 'Ward', 'Richardson', 'Watson', 'Brooks',
      'Chavez', 'Wood', 'James', 'Bennett', 'Gray', 'Mendoza', 'Ruiz', 'Hughes',
      'Price', 'Alvarez', 'Castillo', 'Sanders', 'Patel', 'Myers', 'Long', 'Ross',
      'Foster', 'Jimenez', 'Powell', 'Jenkins', 'Perry', 'Russell', 'Sullivan', 'Bell',
      'Coleman', 'Butler', 'Henderson', 'Barnes', 'Gonzales', 'Fisher', 'Vasquez', 'Simmons'
    ];

    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    return `${firstName} ${lastName}`;
  }

  getRandomLocation() {
    const locations = [
      'New York, New York, United States',
      'Los Angeles, California, United States',
      'Chicago, Illinois, United States',
      'Houston, Texas, United States',
      'Phoenix, Arizona, United States',
      'Philadelphia, Pennsylvania, United States',
      'San Antonio, Texas, United States',
      'San Diego, California, United States',
      'Dallas, Texas, United States',
      'San Jose, California, United States',
      'Austin, Texas, United States',
      'Jacksonville, Florida, United States',
      'Fort Worth, Texas, United States',
      'Columbus, Ohio, United States',
      'Charlotte, North Carolina, United States',
      'San Francisco, California, United States',
      'Indianapolis, Indiana, United States',
      'Seattle, Washington, United States',
      'Denver, Colorado, United States',
      'Washington, District of Columbia, United States',
      'Boston, Massachusetts, United States',
      'El Paso, Texas, United States',
      'Nashville, Tennessee, United States',
      'Detroit, Michigan, United States',
      'Oklahoma City, Oklahoma, United States',
      'Portland, Oregon, United States',
      'Las Vegas, Nevada, United States',
      'Memphis, Tennessee, United States',
      'Louisville, Kentucky, United States',
      'Baltimore, Maryland, United States',
      'Milwaukee, Wisconsin, United States',
      'Albuquerque, New Mexico, United States',
      'Tucson, Arizona, United States',
      'Fresno, California, United States',
      'Mesa, Arizona, United States',
      'Sacramento, California, United States',
      'Atlanta, Georgia, United States',
      'Kansas City, Missouri, United States',
      'Colorado Springs, Colorado, United States',
      'Raleigh, North Carolina, United States',
      'Omaha, Nebraska, United States',
      'Miami, Florida, United States',
      'Long Beach, California, United States',
      'Virginia Beach, Virginia, United States',
      'Oakland, California, United States',
      'Minneapolis, Minnesota, United States',
      'Tulsa, Oklahoma, United States',
      'Tampa, Florida, United States',
      'Cleveland, Ohio, United States',
      'Wichita, Kansas, United States',
      'Arlington, Texas, United States',
      'Mountain View, California, United States',
      'Redwood City, California, United States',
      'Palo Alto, California, United States',
      'Fremont, California, United States',
      'Oakland, California, United States',
      'Berkeley, California, United States',
      'San Mateo, California, United States',
      'Santa Clara, California, United States',
      'Sunnyvale, California, United States'
    ];

    return locations[Math.floor(Math.random() * locations.length)];
  }

  getRandomTimeAgo() {
    const timeUnits = [
      { value: 1, unit: 'minute', unitPlural: 'minutes' },
      { value: 30, unit: 'minute', unitPlural: 'minutes' },
      { value: 1, unit: 'hour', unitPlural: 'hours' },
      { value: 2, unit: 'hour', unitPlural: 'hours' },
      { value: 5, unit: 'hour', unitPlural: 'hours' },
      { value: 1, unit: 'day', unitPlural: 'days' },
      { value: 2, unit: 'day', unitPlural: 'days' },
      { value: 5, unit: 'day', unitPlural: 'days' },
      { value: 1, unit: 'week', unitPlural: 'weeks' },
      { value: 2, unit: 'week', unitPlural: 'weeks' },
      { value: 1, unit: 'month', unitPlural: 'months' },
      { value: 2, unit: 'month', unitPlural: 'months' },
      { value: 3, unit: 'month', unitPlural: 'months' },
      { value: 6, unit: 'month', unitPlural: 'months' },
      { value: 8, unit: 'month', unitPlural: 'months' },
      { value: 1, unit: 'year', unitPlural: 'years' }
    ];

    const timeUnit = timeUnits[Math.floor(Math.random() * timeUnits.length)];
    const isPlural = timeUnit.value > 1;
    const unit = isPlural ? timeUnit.unitPlural : timeUnit.unit;
    return `${timeUnit.value} ${unit} ago`;
  }

  show() {
    if (this.isVisible || this.products.length === 0) {
      return;
    }

    const product = this.getRandomProduct();
    const name = this.getRandomName();
    const location = this.getRandomLocation();
    const timeAgo = this.getRandomTimeAgo();

    // Update content
    const nameEl = this.querySelector('.m-fake-purchase-notification__name');
    const titleEl = this.querySelector('.m-fake-purchase-notification__title');
    const imageEl = this.querySelector('.m-fake-purchase-notification__image img');
    const timeLocationEl = this.querySelector('.m-fake-purchase-notification__time-location');

    if (nameEl) nameEl.textContent = name;
    if (titleEl) titleEl.textContent = product.title;
    if (imageEl) {
      if (product.featured_image && product.featured_image.trim() !== '') {
        imageEl.src = product.featured_image;
        imageEl.alt = product.title || '';
        imageEl.style.display = 'block';
        // Handle image load error
        imageEl.onerror = () => {
          imageEl.style.display = 'none';
        };
      } else {
        imageEl.style.display = 'none';
      }
    }
    if (timeLocationEl) {
      timeLocationEl.textContent = `${timeAgo} - ${location}`;
    }

    // Show notification
    this.classList.remove('m:hidden');
    this.isVisible = true;

    // Auto hide after 5 seconds
    setTimeout(() => {
      this.hide();
    }, 5000);
  }

  hide() {
    if (!this.isVisible) {
      return;
    }

    this.classList.add('m:hidden');
    this.isVisible = false;

    // Schedule next notification
    this.scheduleNext();
  }

  scheduleNext() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    const interval = Math.floor(
      Math.random() * (this.maxInterval - this.minInterval + 1) + this.minInterval
    ) * 1000;

    this.timeoutId = setTimeout(() => {
      this.show();
    }, interval);
  }

  disconnectedCallback() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}

customElements.define('fake-purchase-notification', FakePurchaseNotification);

